module.exports = __webpack_public_path__ + "static/media/movieRecommendation.bc7ee83e.jpg";